export const ERROR_CODE = Object.freeze({
  ORGANIZATIONS_ERR_FORBIDDEN: 'HPE_GL_ORGANIZATIONS_ERR_FORBIDDEN'
})
